import { type TemplateOnlyComponent } from '@ember/component/template-only';
import { on } from '@ember/modifier';

const EditModeToggle: TemplateOnlyComponent<{
  Args: {
    isActive: boolean;
    icon: string;
    buttonText: string;
    onActivate: () => void;
    onDeactivate: () => void;
  };
  Element: HTMLButtonElement;
}> = <template>
  {{#if @isActive}}
    <button
      class="btn btn-primary rounded-start-0 px-2 py-1 btn-sm flex-grow-0 d-flex flex-row align-items-center"
      type="button"
      {{on "click" @onDeactivate}}
      ...attributes
    ><iconify-icon icon={{@icon}} class="fs-4 me-1" /><span
        class="text-nowrap"
      >{{@buttonText}}</span></button>
  {{else}}
    <button
      class="btn btn-outline-primary rounded-start-0 px-2 py-1 btn-sm flex-grow-0 d-flex flex-row align-items-center"
      type="button"
      {{on "click" @onActivate}}
      ...attributes
    ><iconify-icon icon={{@icon}} class="fs-4 me-1" /><span
        class="text-nowrap"
      >{{@buttonText}}</span></button>
  {{/if}}
</template>;

export default EditModeToggle;
